export default "__VITE_ASSET__Gfl_4DX7__"